<template>
<div class="down-file">

<!--  跟需求沟通下是否需要搜索框 todo 图标有问题 todo 文件样式未调整 -->
<!--  <div class="header-query">
    <vs-input
      class="vs-input-el"
      placeholder="文件名称"
      v-model="fileName"
    ></vs-input>
    <vs-button @click="searchHandle">搜索</vs-button>
  </div>-->
 <div
   v-for="(item,index) in fileList"
   :key="index"
   class="down-item">
   <div class="item-left">
     <img
       :src="pdfIcon"
       alt=""
       class="icon-small"
     >
     <div class="span">{{item.fileName}}</div>
   </div>
   <a
     :href="item.fileLink"
     download
     target="_blank"
   >
     <i
       class="el-icon-download down-btn"></i>
   </a>
 </div>
</div>
</template>

<script>
import pdfIcon from '@/assets/images/pdf_icon.png'
export default {
  name: "index",
  data() {
    let _this = this;
    return {
      fileName: '',
      fileList: [
        {
          fileName: `${_this.$t('client_agreement')}.pdf`,
          fileLink: 'https://maxain-prod.s3.ap-southeast-1.amazonaws.com/files/ClientAgreement.pdf'
        },
        {
          fileName: `${_this.$t('risk_agreement')}.pdf`,
          fileLink: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/RiskDisclosureandWarningNotice.pdf'
        },
        {
          fileName: `${_this.$t('privacy_agreement')}.pdf`,
          fileLink: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/PrivacyPolicy.pdf'
        },
        {
          fileName: `${_this.$t('Prevent_money_laundering')}.pdf`,
          fileLink: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/AntiMoneyLaunderingAgreement.pdf'
        },
        {
          fileName: `${_this.$t('saveFileName')}.pdf`,
          fileLink: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/AccountFundsSecurityStatement.pdf'
        }
      ],
      pdfIcon,
    }
  },
  methods: {

    searchHandle() {

    }
  },
}
</script>

<style lang="scss">
.down-file {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 20px;
  .header-query {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    .vs-input-el {
      margin-right: 10px;
    }
  }
  .down-item {
    border: 1px solid #EBE9F1;
    border-radius: 6px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    .item-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-small {
        margin-right: 15px;
      }
    }
    .down-btn {
      color: #000000;
      font-size: 20px;
    }
  }
  .icon-small {
    width: 20px;
    height: 24px;
  }
}
</style>
